import React from 'react'
import Asterisk from './Asterisk';
function DocumentRule() {
    return (
            <span>带<Asterisk color='red'/>的项目必填，其他选填</span>
    )
}

export default DocumentRule